import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { AdminQueryKeys, getOperationalMetrics, type OperationalMetricsResponse } from '../api';

export function useOperationalMetrics(): UseQueryResult<OperationalMetricsResponse> {
  return useQuery({
    queryKey: AdminQueryKeys.operational(),
    queryFn: ({ signal }) => getOperationalMetrics(signal),
    staleTime: 60_000,
  });
}
